import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'safeHtml',
  standalone: false
})
export class SafeHtmlPipe implements PipeTransform {
  constructor(private readonly sanitizer: DomSanitizer) {}

  transform(value: unknown): string {
    if (typeof value !== 'string') {
      return '';
    }

    return this.sanitizer.sanitize(SecurityContext.HTML, value) ?? '';
  }
}
